import './InfoLabel.css'

export function InfoLabel({ type, title, onClick, size = 'sm' }) {
    return <label className={`label label-${type} label-${size}-skynet ${onClick ? 'cursorpointer' : ''}`}
        onClick={onClick}
    >{title}</label>
}